module.exports = __webpack_public_path__ + "img/gasbot_side_right.e8c8c9c3.png";